// extracted by mini-css-extract-plugin
export default {"root":"style_root__RcxJV","icon":"style_icon__XnMzu","label":"style_label__6WjUl","error":"style_error__sso1h"};